export const generateRandomPrice = (currentPrice, volatility = 0.25) => {
  const change = (Math.random() - 0.5) * volatility;
  return +(currentPrice + change).toFixed(2);
};

export const calculateProfitLoss = (avgPrice, currentPrice, quantity, contractSize = 500000) => {
  const priceDiff = currentPrice - avgPrice;
  const profitLoss = priceDiff * quantity * contractSize;
  return Math.round(profitLoss);
};

export const calculateProfitRate = (avgPrice, currentPrice) => {
  return +((currentPrice - avgPrice) / avgPrice * 100).toFixed(2);
};

const logTemplates = {
  INFO: [
    { category: 'API', message: '시세 데이터 정상 수신 중' },
    { category: 'STRATEGY', message: '매수 시그널 확인 중' },
    { category: 'STRATEGY', message: '매도 시그널 확인 중' },
    { category: 'SYSTEM', message: '시스템 정상 작동 중' },
    { category: 'ORDER', message: '주문 대기 중' },
  ],
  WARNING: [
    { category: 'STRATEGY', message: 'RSI 과매수 구간 진입' },
    { category: 'SYSTEM', message: '메모리 사용률 75% 도달' },
    { category: 'API', message: '네트워크 지연 감지' },
  ],
  ERROR: [
    { category: 'API', message: '시세 데이터 수신 지연' },
    { category: 'ORDER', message: '주문 전송 실패' },
    { category: 'SYSTEM', message: '데이터베이스 연결 오류' },
  ],
};

export const generateRandomLog = () => {
  const levels = ['INFO', 'INFO', 'INFO', 'WARNING', 'ERROR']; // INFO가 더 자주 발생
  const level = levels[Math.floor(Math.random() * levels.length)];
  const templates = logTemplates[level];
  const template = templates[Math.floor(Math.random() * templates.length)];

  return {
    id: `LOG${Date.now()}`,
    timestamp: new Date().toISOString(),
    level,
    category: template.category,
    message: template.message,
  };
};
